import React from 'react'
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react'
import { ModalBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { usePasswordLockModal } from '../../../context/PasswordLockContext'
import { getLink } from '../../../utils'

export function BlockedPasswordLockModal() {
    const { t } = useTranslation('login_page');
    
    const { passwordLockModal } = usePasswordLockModal()
    const { hasModalOpen, closeModal, passwordLockCount } = passwordLockModal
    
    const modalShouldOpen = hasModalOpen && passwordLockCount === 5

    function handleButtonClick() {
        closeModal()
        window.location.href = getLink('recuperar/senha');
    }

    return (
      <SmlsModal
        isOpen={modalShouldOpen}
        type="right"
        toggle={closeModal}
        onExit={closeModal}
        className="smls-register-error-modal modal-response-status"
      >
        <ModalBody className="smls-modal-body">
          <div className="smls-modal-header">
            <h4>{t('locked_password.title')}</h4>
          </div>
          <div className="smls-modal-text">
            <p>{t('locked_password.subtitle')}</p>
          </div>

          <div className="btns-modal-response">
            <SmlsButton className="primary-btn-modal" id="btn_gotIt" onClick={handleButtonClick} text={t('locked_password.button')} />
          </div>
        </ModalBody>
      </SmlsModal>
    )
}